/*
 * improvemint-condition.js — the "Condition guide" drawer on a refurbished
 * product page (GP, 2026-10-21). Markup: snippets/improvemint-refurb-condition.liquid
 * (part 'guide'); opened by the block's [data-im-cond-guide] link.
 *
 * The same drawer the store and delivery pickers use (.im-modal--drawer), with
 * its own attributes so the three scripts never answer each other's clicks:
 *   [data-im-cond-guide]        opens it
 *   [data-im-cond-close]        the scrim and the × close it
 *   Escape                      closes it
 * Focus goes to the close button on open, Tab and Shift+Tab stay inside the
 * panel, and focus returns to the link on close.
 *
 * The drawer is moved to <body> the first time it opens. It is rendered inside
 * the product section, and Hyper moves blocks around in there with innerHTML
 * copies (assets/product-info.js, handleBlocksPosition); at the end of <body>,
 * like the other Improvemint drawers, nothing above it can clip or re-create it.
 * It is looked up by id on every open for the same reason, never cached.
 *
 * Loaded only on a page that renders the drawer. No dependencies; idempotent.
 */
(function () {
  if (window.__imConditionInit) return;
  window.__imConditionInit = true;

  var origin = null;

  function drawer() {
    return document.getElementById('im-condition-guide');
  }

  function focusables(m) {
    return Array.prototype.filter.call(
      m.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open(trigger) {
    var m = drawer();
    if (!m) return;
    if (m.parentNode !== document.body) document.body.appendChild(m);
    origin = trigger || null;
    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('im-modal-open');
    var closeBtn = m.querySelector('.im-modal__close');
    // A macrotask, not now: the theme's own document-level click handlers run
    // in this same dispatch and can take focus back (same as the delivery
    // drawer, where it was measured).
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 0);
  }

  function close() {
    var m = drawer();
    if (!m || m.hidden) return;
    m.hidden = true;
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('im-modal-open');
    // The link may have been re-created by a desktop/mobile switch since it
    // opened the drawer; fall back to the one on the page now.
    var back = origin && origin.isConnected ? origin : document.querySelector('[data-im-cond-guide]');
    if (back && back.focus) back.focus();
    origin = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-im-cond-guide]');
    if (trigger) { e.preventDefault(); open(trigger); return; }
    if (e.target.closest('#im-condition-guide [data-im-cond-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    var m = drawer();
    if (!m || m.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables(m);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !m.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !m.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });
})();
